export const GET_VALIDATE_ACTION_PLAN = "GET_VALIDATE_ACTION_PLAN"
export const GET_VALIDATE_ACTION_PLAN_SUCCESS = "GET_VALIDATE_ACTION_PLAN_SUCCESS"
// export const PATCH_CONFIRM_ACTION_PLAN = "PATCH_CONFIRM_ACTION_PLAN"
export const PATCH_CONFIRM_ACTION_PLAN_SUCCESS = "PATCH_CONFIRM_ACTION_PLAN_SUCCESS"
export const PATCH_VALIDATE_ACTION_PLAN = "PATCH_VALIDATE_ACTION_PLAN"
export const PATCH_VALIDATE_ACTION_PLAN_SUCCESS = "PATCH_VALIDATE_ACTION_PLAN_SUCCESS"
export const SET_ACTION_PLAN_ID_SUCCESS = "SET_ACTION_PLAN_ID_SUCCESS"
export const VALID_OR_REJECT_TASKS_ACTION_PLAN = "VALID_OR_REJECT_TASKS_ACTION_PLAN"

// SPECIAL FOR ACTION PLAN THREAD
export const GET_ACTION_PLAN_THREAD_BY_ACTION_PLAN_ID = "GET_ACTION_PLAN_THREAD_BY_ACTION_PLAN_ID"
export const GET_ACTION_PLAN_THREAD_BY_ACTION_PLAN_ID_SUCCESS =
  "GET_ACTION_PLAN_THREAD_BY_ACTION_PLAN_ID_SUCCESS"
export const POST_MESSAGE_ACTION_PLAN_THREAD = "POST_MESSAGE_ACTION_PLAN_THREAD"
